<template>
  <div class="page padding">
    <b-card no-body>
      <div class="p-3">
        <h3 class="mb-3">{{ nombreProductor }}</h3>
        <hr />
        <b-form>
          <!-- IVA -->
          <b-row v-if="pas.iva && !pas.iva.hide">
            <b-col md="11">
              <b-row>
                <b-col md="4">
                  <b-form-group label="Condición IVA">
                    <b-form-select :options="condicionesIva" v-model="pas.iva.desc_cond" :disabled="!pas.iva.editing"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Nro. de Inscripción">
                    <b-form-input placeholder="Ingrese Nro. de Inscripción" v-model="pas.iva.nro_inscripcion" :disabled="!pas.iva.editing"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Constancia">
                    <b-form-file drop-placehoder="Adjuntar" placeholder="Adjuntar" v-model="pas.iva.adjunto" :disabled="!pas.iva.editing"></b-form-file>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="1">              
              <b-button class="mb-2 button-action" variant="warning" @click="pas.iva = editar(false, 0, pas.iva)/*pas.iva.editing = false*/" v-if="pas.iva.editing">
                <i class="fa fa-close"></i>
              </b-button>
              <b-button class="mb-2 button-action" variant="primary" @click="pas.iva = editar(true, 0, pas.iva)/*pas.iva.editing = true*/" v-if="!pas.iva.editing">
                <i class="fa fa-pencil"></i>
              </b-button>
              <b-button class="mb-2 button-action" variant="danger" @click="delTax('iva')" v-else>
                <i class="fa fa-trash"></i>
              </b-button>              
            </b-col>
          </b-row>
          <!-- FIN IVA -->

          <!-- IIBB -->
          <b-row v-if="pas.iibb && !pas.iibb.hide">
            <b-col md="11">
              <b-row>
                <b-col md="4">
                  <b-form-group label="Condición IIBB">
                    <b-form-select :options="condicionesIIBB" v-model="pas.iibb.desc_cond" :disabled="!pas.iibb.editing"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Nro. de Inscripción">
                    <b-form-input placeholder="Ingrese Nro. de Inscripción" v-model="pas.iibb.nro_inscripcion" :disabled="!pas.iibb.editing"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Constancia">
                    <b-form-file drop-placehoder="Adjuntar" placeholder="Adjuntar" v-model="pas.iibb.adjunto" :disabled="!pas.iibb.editing"></b-form-file>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="1">
              <b-button class="mb-2 button-action" variant="warning" @click="pas.iibb = editar(false, 1, pas.iibb)" v-if="pas.iibb.editing">
                <i class="fa fa-close"></i>
              </b-button>
              <b-button class="mb-2 button-action" variant="primary" @click="pas.iibb = editar(true, 1, pas.iibb)" v-if="!pas.iibb.editing">
                <i class="fa fa-pencil"></i>
              </b-button>
              <b-button class="mb-2 button-action" variant="danger" @click="delTax('iibb')" v-else>
                <i class="fa fa-trash"></i>
              </b-button>
            </b-col>
          </b-row>
          <!-- FIN IIBB -->
          <!-- GANANCIAS -->
          <b-row v-if="pas.ganancias && !pas.ganancias.hide">
            <b-col md="11">
              <b-row>
                <b-col md="4">
                  <b-form-group label="Condición Ganancias">
                    <b-form-select :options="condicionesGanancias" v-model="pas.ganancias.desc_cond" :disabled="!pas.ganancias.editing"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Nro. de Inscripción">
                    <b-form-input placeholder="Ingrese Nro. de Inscripción" v-model="pas.ganancias.nro_inscripcion" :disabled="!pas.ganancias.editing"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Constancia">
                    <b-form-file drop-placehoder="Adjuntar" placeholder="Adjuntar" v-model="pas.ganancias.adjunto" :disabled="!pas.ganancias.editing"></b-form-file>
                  </b-form-group>
                </b-col>
                <b-col sm="1" class="text-center"> </b-col>
              </b-row>
            </b-col>
            <b-col md="1">
              <b-button class="mb-2 button-action" variant="warning" @click="pas.ganancias = editar(false, 2, pas.ganancias)" v-if="pas.ganancias.editing">
                <i class="fa fa-close"></i>
              </b-button>
              <b-button class="mb-2 button-action" variant="primary" @click="pas.ganancias = editar(true, 2, pas.ganancias)" v-if="!pas.ganancias.editing">
                <i class="fa fa-pencil"></i>
              </b-button>              
              <b-button class="mb-2 button-action" variant="danger" @click="delTax('ganancias')" v-else>
                <i class="fa fa-trash"></i>
              </b-button>
            </b-col>
          </b-row>
          <!-- FIN GANANCIAS -->
          <!-- SERVICIOS SOCIALES -->
          <b-row v-if="pas.ss && !pas.ss.hide">
            <b-col md="11">
              <b-row>
                <b-col md="4">
                  <b-form-group label="Condición Servicios Sociales">
                    <b-form-select :options="condicionesSS" v-model="pas.ss.desc_cond" :disabled="!pas.ss.editing"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Nro. de Inscripción">
                    <b-form-input placeholder="Ingrese Nro. de Inscripción" v-model="pas.ss.nro_inscripcion" :disabled="!pas.ss.editing"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Constancia">
                    <b-form-file drop-placehoder="Adjuntar" placeholder="Adjuntar" v-model="pas.ss.adjunto" :disabled="!pas.ss.editing"></b-form-file>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="1">
              <b-button class="mb-2 button-action" variant="warning" @click="pas.ss = editar(false, 3, pas.iva)" v-if="pas.ss.editing">
                <i class="fa fa-close"></i>
              </b-button>
              <b-button class="mb-2 button-action" variant="primary" @click="pas.ss = editar(true, 3, pas.ss)" v-if="!pas.ss.editing">
                <i class="fa fa-pencil"></i>
              </b-button>              
              <b-button class="mb-2 button-action" variant="danger" @click="delTax('ss')" v-else>
                <i class="fa fa-trash"></i>
              </b-button>              
            </b-col>
          </b-row>
          <!-- FIN SERVICIOS SOCIALES -->
          <!-- OTROS -->
          <div v-if="pas.otros.length">
            <hr />
            <h5>Otros Impuestos</h5>
            <b-row v-for="(otro, index) in pas.otros" :key="index">
              <b-col>
                <b-form-group label="Nombre">
                  <b-form-input placeholder="Ingrese Nombre" v-model="otro.nombre" :disabled="!otro.editing" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Condición">
                  <b-form-input placeholder="Ingrese condición" v-model="otro.desc_cond" :disabled="!otro.editing" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Nro. de Inscripción">
                  <b-form-input placeholder="Ingrese Nro. de Inscripción" v-model="otro.nro_inscripcion" :disabled="!otro.editing" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Constancia">
                  <b-form-file drop-placehoder="Adjuntar" placeholder="Adjuntar" v-model="otro.adjunto" :disabled="!otro.editing" required></b-form-file>
                </b-form-group>
              </b-col>
              <b-col sm="1" class="text-center">
                <!--b-button class="button-action" variant="warning" @click="otro.editing = false" v-if="otro.editing">
                  <i class="fa fa-close"></i>
                </b-button>
                <b-button class="mb-4 button-action" variant="primary" @click="otro.editing = true" v-if="!otro.editing">
                  <i class="fa fa-pencil"></i>
                </b-button-->
                <div class="text-center mt-4">
                  <b-button class="mb-4 button-action" variant="danger" @click="delOtro(index)">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- FIN OTROS -->

          <!-- EXCLUIDOS -->
          <div v-if="pas.excluidos.length">
            <hr />
            <h5>Excluidos</h5>
            <b-row v-for="(exc, index) in pas.excluidos" :key="index">
              <b-col>
                <b-form-group :label="'Condición ' + exc.nombre">
                  <b-form-input placeholder="Ingrese condición" v-model="exc.desc_cond" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Nro. de Inscripción">
                  <b-form-input placeholder="Ingrese Nro. de Inscripción" v-model="exc.nro_inscripcion" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="1" class="text-center"><b-button class="button-action" variant="warning" @click="delExcluido(exc.indice)"><i class="fa fa-close"></i></b-button></b-col>
            </b-row>
          </div>
          <!-- FIN EXCLUIDOS -->
        </b-form>
      </div>
      <b-card-footer>        
        <b-row>
          <b-col sm="8">
            <b-button  class="button-action" @click="resetForm" title="Deshacer todos los cambios"> <i class="fa fa-undo"></i> Reset </b-button>
          </b-col>
          <b-col sm="2" class="text-right" >
            <b-button class="button-action" variant="primary" @click="addTax" style="margin-bottom:0"> <i class="fa fa-plus"></i> Agregar Impuesto </b-button>&nbsp;
          </b-col>
          <b-col sm="2" class="text-right">
            <b-tooltip target="botonEnviar" triggers="hover" v-if="editing">
              Se enviara mail de solicitud para los cambios, los mismos no son automáticos.
            </b-tooltip>
            <b-button id="botonEnviar" class="button-action" variant="success" @click="sendUpdate" :disabled="!editing || sending">
              <i class="fa fa-send-o" v-if="!sending"></i>
              <i class="fa fa-spinner fa-spin" v-else></i>
              &nbsp;Informar Actualización
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import M from 'minimatch';
import { relativeTimeRounding } from 'moment';

export default {
  name: 'DatosImpositivosPasPage',
  data() {
    return {
      sending: false,
      pas: {
        iva: {
          desc_cond: '',
          nro_inscripcion: '',
          constancia: false,
          editing: false,
          adjunto: false,
          hide: false         
        },
        iibb: {
          desc_cond: '',
          nro_inscripcion: '',
          constancia: false,
          editing: false,
          adjunto: false,
          hide: false
        },
        ganancias: {
          desc_cond: '',
          nro_inscripcion: '',
          constancia: false,
          editing: false,
          adjunto: false,
          hide: false
        },
        ss: {
          desc_cond: '',
          nro_inscripcion: '',
          constancia: false,
          editing: false,
          adjunto: false,
          hide: false
        },
        otros: [],
        excluidos: [],
        anteriores: []
      },
    };
  },
  methods: {
    editar(editando, index, item){
      if (editando) this.pas.anteriores[index] = JSON.parse(JSON.stringify(item));
      else{
        item = JSON.parse(JSON.stringify(this.pas.anteriores[index]));
        this.pas.anteriores.splice(index, 1);
      } 

      item.editing = editando;
      return item;
    },
    getDatosImpositivos() {
      const cod_agente = this.$store.state.auth.cod_agente;

      this.$api(`pas/datos-impositivos/${cod_agente}`).then((res) => {
        const iva = res.data.find((imp) => imp.cod_impuesto == 10);
        const iibb = res.data.find((imp) => imp.cod_impuesto == 8);
        const ganancias = res.data.find((imp) => imp.cod_impuesto == 25 || imp.cod_impuesto == 7);
        const ss = res.data.find((imp) => imp.cod_impuesto == 9);

        this.pas.iva = {
          nombre: 'iva',
          desc_cond: iva.desc_cond,
          nro_inscripcion: iva.nro_inscripcion,
          adjunto: false,
          editing: false,
        };

        this.pas.iibb = {
          nombre: 'iibb',
          desc_cond: iibb.desc_cond,
          nro_inscripcion: iibb.nro_inscripcion,
          adjunto: false,
          editing: false,
        };

        this.pas.ganancias = {
          nombre: 'ganancias',
          desc_cond: ganancias.desc_cond,
          nro_inscripcion: ganancias.nro_inscripcion,
          adjunto: false,
          editing: false,
        };

        this.pas.ss = {
          nombre: 'servicios sociales',
          desc_cond: ss.desc_cond,
          nro_inscripcion: ss.nro_inscripcion,
          adjunto: false,
          editing: false,
        };
      });
    },
    addTax() {
      this.pas.otros.push({
        nombre: '',
        desc_cond: '',
        nro_inscripcion: '',
        constancia: false,
        editing: true,
      });
    },
    delTax(tax) {
      this.$bvModal
        .msgBoxConfirm('¿Desea excluir el impuesto seleccionado?')
        .then((value) => {
          if (value) {
            let t = this.pas[tax];
            t.indice = tax;
            this.pas.excluidos.push(t);
            this.pas[tax].editing = false;
            this.pas[tax].hide = true;
          }
        })
        .catch(() => null);
    },
    delExcluido(index){      
        this.pas[index].hide = false;
        this.pas.excluidos.splice(index, 1);        
    },
    delOtro(index) {
      this.pas.otros.splice(index, 1);
    },
    sendUpdate: async function () {
      const cod_agente = this.$store.state.auth.cod_agente;
      const email_pas = this.$store.state.auth.email;
      const { otros, excluidos, ...incluidos } = this.pas;
      const inc = Object.values(incluidos).filter(x => x.editing).concat(otros);
      
      
      
      const files = inc.map((item) => {
        return {
          nombre: item.nombre,
          adjunto: item.adjunto,
        };
      });

      let conError = false;
      inc.forEach(x => {
        if (!x.nombre){
          this.$toast.error('Debe completar el Nombre a todos los impuestos que desea actualizar', 'Error: ');
          conError = true;
        }else{
          if (!x.nro_inscripcion){
            this.$toast.error('Debe incluir un N° de Inscripcion correspondiente al impuesto "'+x.nombre+'"', 'Error: ');
            conError = true;
          }
          if (!x.desc_cond){
            this.$toast.error('Debe incluir un la condicion correspondiente al impuesto "'+x.nombre+'"', 'Error: ');
            conError = true;
          }
        }         
      });      

      if (conError) return;

      inc.forEach(x => {
        if (!x.adjunto){
          this.$toast.error('Debe adjuntar la constacia correspondiente al impuesto "'+x.nombre+'"', 'Error: ');
          conError = true;
        } 
      });
      
      if (conError) return;

      const incSinAdjunto = inc.map((item) => {
        delete item.adjunto;
        return item;
      });

      const formData = new FormData();

      formData.append('cod_agente', cod_agente);
      formData.append('pas_email', email_pas);
      formData.append('incluidos', JSON.stringify(incSinAdjunto));
      formData.append('excluidos', JSON.stringify(excluidos));
      files.forEach((file) => {
        if (file.adjunto) {
          formData.append('constancia_' + file.nombre, file.adjunto);
        }
      });

      for (var pair of formData.entries()) {
        //console.log(pair[0]+ ', ' + pair[1]); 
      }
      this.sending = true;
      await this.$api
        .post(`pas/datos-impositivos/${cod_agente}`, formData, {
          headers: {
            'Content-type': 'multipart/form-data',
          },
        })
        .then((res) => {
          this.$toast.success(res.data);
        });
      this.sending = false;
    },
    resetForm() {
      this.pas.otros = [];
      this.pas.excluidos = [];
      this.getDatosImpositivos();
    },
  },
  computed: {
    condicionesIva() {
      return this.$store.state.condicionesIva;
    },
    condicionesIIBB() {
      return this.$store.state.condicionesIIBB;
    },
    condicionesGanancias() {
      return this.$store.state.condicionesGanancias;
    },
    condicionesSS() {
      return this.$store.state.condicionesSS;
    },
    nombreProductor() {
      return this.$store.getters['NOMBRE_PRODUCTOR'];
    },
    editing() {      
      if (this.pas.otros.length){                
        return true;
      }
      const taxes = Object.values(this.pas);      
      let r = taxes.some((tax) => tax.editing) || this.pas.excluidos.length;
      return r;
    },
  },
  created() {
    this.getDatosImpositivos();
  },
};
</script>


<style scoped>
@media (max-width: 768px) {
  .button-action {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
